import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import { Drawer } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles((theme) => ({
	tempDrawerContainer: {
		width: '29em',
		paddingLeft: '2em',
		'& svg': {
			verticalAlign: 'middle',
		},
		'& button': {
			textTransform: 'none',
			width: '25em',
			marginTop: '2em',
		},
		marginTop: '1em',
		'&h2, h3, h4, h5, h6': {
			margin: '0',
			padding: '0',
		},
	},
	drawerHeader: {
		fontWeight: 'normal',
	},
	checkBoxLabel: {
		fontWeight: 'bold',
	},
	confirmationMessage: {
		paddingRight: '1em',
	},
}));

//assets confirmation drawer when removing an asset and removing tags from bulk container
const AssetsTempDrawer = (props) => {
	const classes = useStyles();
	const handleClose = () => {
		props.setOpen(false);
	};

	const handleRemoveBtnClick = () => {
		props.handleRemoveBtnClick();
	};
	const handleCancelBtnClick = () => {
		props.setOpen(false);
	};

	return (
		<div>
			<Drawer
				anchor="right"
				open={props.open}
				variant="temporary"
				onClose={handleClose}
				classes={{ paper: classes.tempDrawerContainer }}
				data-cy="assets-temp-drawer"
			>
				<h1 className={classes.drawerHeader}>
					<RemoveCircleIcon fontSize="default" />
					{props.removeMsg}
				</h1>
				<span className={classes.confirmationMessage}>
					{props.removeConfirmationMsg} {props.assetName}
				</span>
				{props.checkBoxLabelTxt ? (
					<span>
						<Checkbox
							checked={props.checked}
							color="primary"
							onChange={props.handleCheckBoxOnChange}
							inputProps={{ 'aria-label': 'primary checkbox' }}
						></Checkbox>
						<span className={classes.checkBoxLabel}>{props.checkBoxLabelTxt}</span>
					</span>
				) : (
					''
				)}
				<Button
					variant="contained"
					color="primary"
					size="small"
					onClick={handleRemoveBtnClick}
					data-cy="assets-temp-drawer-primary-btn"
				>
					{props.removeBtnTxt}
				</Button>
				<Button variant="outlined" color="default" size="small" onClick={handleCancelBtnClick}>
					Cancel
				</Button>
			</Drawer>
		</div>
	);
};

export default AssetsTempDrawer;
